// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/lane/Development/lanesawyer.github.io/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/home/lane/Development/lanesawyer.github.io/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("/home/lane/Development/lanesawyer.github.io/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kaladin-js": () => import("/home/lane/Development/lanesawyer.github.io/src/pages/kaladin.js" /* webpackChunkName: "component---src-pages-kaladin-js" */),
  "component---src-pages-tech-js": () => import("/home/lane/Development/lanesawyer.github.io/src/pages/tech.js" /* webpackChunkName: "component---src-pages-tech-js" */)
}

